import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { HeightObserverContextWrapper } from '@scoir/height-observer'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import HeaderNavigation from 'components/HeaderNavigation'
import Snackbar from 'components/Snackbar'

const MAIN_CONTENT = 'app-main-content'

const useStyles = makeStyles((theme) => ({
  layout: {
    position: 'relative',
    backgroundColor: theme.palette.background.default,
  },
  wrapper: {
    minHeight: 'calc(100vh - 96px)',
    [theme.breakpoints.down('sm')]: {
      minHeight: 'calc(100vh - 88px)',
    },
    position: 'relative',
    overflow: 'hidden',
    zIndex: 0,
  },
}))

const InAppLayout = ({ children, footer, location }) => {
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <HeightObserverContextWrapper>
        <Switch>
          <Route
            path={`${import.meta.env.BASE_URL}/app-profile`}
            exact={false}
            component={() => null}
          />
          <Route
            path={`${import.meta.env.BASE_URL}/mobile/documents`}
            exact={false}
            component={() => null}
          />
          <Route path="*">
            <HeaderNavigation
              location={location}
              skipNavId={MAIN_CONTENT}
            />
          </Route>
        </Switch>
        <div className={classes.wrapper}>
          <main id={MAIN_CONTENT}>{children}</main>
        </div>
        {footer}
        <Snackbar />
      </HeightObserverContextWrapper>
    </div>
  )
}

InAppLayout.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  location: PropTypes.object.isRequired,
}

export default InAppLayout
